/* eslint-disable */

export const CommerceIntentStatus = {
  Created: 'created',
  RequirementsPending: 'requirements_pending',
  Reserved: 'reserved',
  PaymentPending: 'payment_pending',
  Processing: 'processing',
  Succeeded: 'succeeded',
  Declined: 'declined',
  Blocked: 'blocked',
  RecoveryRequired: 'recovery_required',
  Expired: 'expired'
} as const;
export type CommerceIntentStatus = typeof CommerceIntentStatus[keyof typeof CommerceIntentStatus];
